import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';

import { ImageSelectionDirectiveModule } from 'app/image-selection.directive';
import { MatModule } from 'core/material/mat.module';
import { PipesModule } from 'core/pipes/pipes.module';
import { GalleryComponent } from './gallery.component';

import { TranslationModule } from 'core/translation/translation.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ImageSelectionDirectiveModule,
    MatModule,
    NgxPaginationModule,
    TranslationModule,
    PipesModule,
  ],
  declarations: [
    GalleryComponent,
  ],
  exports: [
    GalleryComponent,
  ],
})
export class GalleryModule { }



// WEBPACK FOOTER //
// ./src/app/gallery/gallery.module.ts